import React from 'react';
import PropTypes from 'prop-types';

import GridContainer from 'components/atoms/Layout/Grid/GridContainer';
import GridItem from 'components/atoms/Layout/Grid/GridItem';
import { LogoColor } from 'assets/imagesList';
import Button from 'components/atoms/Inputs/Buttons/Button';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import { useHeaderStyles } from './headerStyles';
import { useActions } from '../../../overmind';

export default function Header(props) {
  const classes = useHeaderStyles();
  const actions = useActions();

  return (
    <>
      {props.hideHeader ? (
        <></>
      ) : (
        <GridContainer
          direction="row"
          justify="center"
          alignItems="center"
          style={{
            marginBottom: props.adjustMargin ? '0px' : '24px',
          }}
        >
          {!props.hideLeftButton && (
            <GridItem className={classes.leftSide}>
              <Button
                color={props.buttonColor ? props.buttonColor : 'default'}
                onClick={() => actions.goBack()}
                style={{ paddingLeft: 0, marginLeft: 0 }}
              >
                <>
                  <NavigateBeforeIcon />
                </>
              </Button>
            </GridItem>
          )}
          <img
            src={props.logo ? props.logo : LogoColor}
            width={props.adjustMargin != null ? '80px' : '50px'}
            alt="Blueprint Beauty logo"
            style={{ marginTop: 30 }}
          />
        </GridContainer>
      )}
    </>
  );
}

Header.propTypes = {
  hideHeader: PropTypes.bool,
  hideLeftButton: PropTypes.bool,
  previousPageRoute: PropTypes.string,
  buttonColor: PropTypes.string,
};
